const application = {
  app_id: process.env.REACT_APP_APPLICATION_ID,
  app_secret: process.env.REACT_APP_APPLICATION_SECRET,
};

export const signIn = async (email, password) => {
  const response = await fetch(`${process.env.REACT_APP_USER_SERVICE_URL}/users/sign_in.json`, {
    body: JSON.stringify({
      user: {
        application,
        email,
        password,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

  if (! response.ok) throw await response.json();
  const jsonResponse = await response.json();
  return jsonResponse;
};

export const mfaAuthentication = async (mfa_token, auth_code) => {
  const response = await fetch(`${
    process.env.REACT_APP_USER_SERVICE_URL}/users/authorize_multifactor_authentication.json`, {
    body: JSON.stringify({
      user: {
        auth_code,
        mfa_token,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

  if (! response.ok) throw await response.json();
  const jsonResponse = await response.json();
  return jsonResponse;
};

export const getUserData = async (access_token) => {
  const response = await fetch(`${process.env.REACT_APP_USER_SERVICE_URL}/users/is_valid.json`, {
    body: JSON.stringify({
      user: {
        access_token,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

  if (! response.ok) throw response;
  const jsonResponse = await response.json();
  return jsonResponse;
};
